import AddIcon from '@mui/icons-material/Add';
import { Button, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useRoles from 'common/hooks/useRoles';
import { listVendorsByPage } from 'store/thunks/vendorManagementThunk';
import AddVendorDialog from './components/AddVendorDialog';
import VendorManagementFilterButton from './components/VendorManagementFilterButton';
import VendorManagementFilterStatusBar from './components/VendorManagementFilterStatusBar';
import VendorManagementTable from './components/VendorManagementTable';

const VendorManagement = () => {
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const hasAccess = useRoles();

  useEffect(() => {
    document.title = 'Vendor Management - SmartOS';
    dispatch(listVendorsByPage({ page: 1 }));
  }, [dispatch]);

  return (
    <>
      <Grid container sx={{ px: 3, pb: 2 }} direction='column'>
        <Grid item container alignItems='center' sx={{ py: 1.5 }}>
          <Grid item sx={{ flexGrow: 1 }}>
            <VendorManagementFilterStatusBar />
          </Grid>
          <Grid item sx={{ display: 'flex', gap: 1 }}>
            {hasAccess.addVendor && (
              <Button
                variant='contained'
                startIcon={<AddIcon />}
                onClick={() => setDialogOpen(true)}
              >
                Add Vendor
              </Button>
            )}
            <VendorManagementFilterButton />
          </Grid>
        </Grid>

        <Grid item container sx={{ mt: 1 }}>
          <VendorManagementTable />
        </Grid>
      </Grid>

      <AddVendorDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
};

export default VendorManagement;
